// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"7":"c1fe80","101":"f52e60","154":"07a8f6","267":"960f60","331":"dbe0b3","368":"75537b","769":"14f39b","848":"537c13"}[chunkId] + ".js";
};